import { render, staticRenderFns } from "./_DefaultLayout.vue?vue&type=template&id=094a098a&scoped=true&"
import script from "./_DefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./_DefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./_DefaultLayout.vue?vue&type=style&index=0&id=094a098a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094a098a",
  null
  
)

export default component.exports